import request from './request'

export function getTemplateConfig() {
  return request({
    url: '/config/template',
    method: 'get'
  })
}

export function getModuleTemplate(module) {
  return request({
    url: '/config/module-template',
    method: 'get',
    params: { module }
  })
}
